/**
 * Cloud command for the firmware dialog's reboot-to-update button.
 *
 * Generic Reboot Device stays `reboot_device` and must not apply an update.
 * Edgecaster Max has historically supported `apply_update`. Edgecaster uses
 * it only when the device agent explicitly advertises that command; old
 * Trogdor agents must keep receiving their legacy `reboot_device` command.
 */
function dedicatedRebootToUpdateCommand(productName, deviceState) {
  if (productName === 'edgecaster_max') {
    return 'apply_update'
  }
  var capabilities = deviceState && deviceState.command_capabilities
  return capabilities && capabilities.apply_update === true
    ? 'apply_update'
    : 'reboot_device'
}

function updateStatusNeedsRebootToUpdate(status) {
  var s = status == null ? '' : String(status).trim().toLowerCase()
  return s === 'awaiting reboot' || s === 'update downloaded' || s === 'awaiting apply'
}

module.exports = {
  dedicatedRebootToUpdateCommand: dedicatedRebootToUpdateCommand,
  updateStatusNeedsRebootToUpdate: updateStatusNeedsRebootToUpdate,
}
